import React, { useEffect, useState } from 'react';
import styles from './index.module.scss';
import { getCaptcha } from '@src/services/Captcha';
import { getSmsCode } from '@src/services/SmsCode';

//导入antd
import { Form, Input, Button, Upload, message, Spin } from 'antd';
import { TabletOutlined, SafetyOutlined } from '@ant-design/icons';
// 导入react-redux
import { useSelector } from 'react-redux';

export type SMSProps = {
    form: any;
    isNeedLabel?: boolean;
    isNeedCaptcha?: boolean;
    useType: string;
    name?: string;
    isNotNeedPhone?: boolean;
    label?: string;
    needPrefix?: boolean;
    size?: any;
    changeQuery?:any;
  };
  
  export const SmsVerificationCode: React.FC<SMSProps> = (props) => {
    const INIT_COUNT = 60;
    let interval: any;
    const {
      isNeedLabel,
      useType,
      form,
      isNeedCaptcha,
      name,
      isNotNeedPhone,
      label,
      needPrefix,
      size,
      changeQuery
    } = props;
    const { getFieldValue, validateFields } = form;
    const [isPending, setIsPending] = useState(false);
    let [count, setCount] = useState(INIT_COUNT);
    const [captchaCode, setCaptchaCode] = useState<string>();
    const [captchaUniqueId, setCaptchaUniqueId] = useState<string>('');
    const [captchaLoading, setCaptchaLoading] = useState<boolean>(false);
    //电话号码
    const phoneNum = useSelector((state: any) => state.user.userInfo.loginName);
  
    const countDown = () => {
      if (count === 0) {
        setIsPending(false);
        setCount(INIT_COUNT);
  
        clearInterval(interval);
      } else {
        setIsPending(true);
        setCount(count--);
      }
    };
  
    const refreshCaptcha = () => {
      setCaptchaLoading(true);
      getCaptcha({ useType }).then((res:any) => {
        setCaptchaLoading(false);
        setCaptchaCode(res.data.captchaCode);
        setCaptchaUniqueId(res.data.captchaUniqueId);
      }).finally(() => {
        setCaptchaLoading(false);
      });
    };
  
    const getSmsCodeByPhone = () => {
      const needValidateFields = isNeedCaptcha
        ? ['phoneNum', 'captcha']
        : ['phoneNum'];
      validateFields(needValidateFields).then((values: any) => {
        interval = setInterval(() => countDown(), 1000);
        getSmsCode({
          captchaCode: getFieldValue('captcha'),
          captchaUniqueId,
          phoneNum,
          useType,
        })
          .then(() => {
            message.info('短信验证码发送成功');
          })
          .catch((err:any) => {
            setIsPending(false);
            setCount(INIT_COUNT);
            clearInterval(interval);
            isNeedCaptcha && refreshCaptcha();
          });
      });
    };
  
    const getCode = () => {
      getSmsCodeByPhone();
    };

    //如果手机验证码输入框里面有值，把isQuery设置为true
    const handleSmsCodeChange = (e: any) => {
      if (e.target.value) {
        changeQuery(true);
      }else{
        changeQuery(false);
      }
    };
  
    useEffect(() => refreshCaptcha(), []);
  
    return (
      <div className={styles['sms-code']}>
        {isNeedCaptcha && (
          <Form.Item
            label={isNeedLabel ? '图片验证码' : null}
            required
            className={[styles.item,styles.form_item].join(' ')}
          >
            <div className={styles['captcha-box']}>
              <div className={styles['captcha-content']}>
                <Form.Item
                  name="captcha"
                  noStyle
                  rules={[
                    {
                      required: true,
                      message: '请输入图片验证码!',
                    },
                    {
                      len: 5,
                      message: '请输入5位图片验证码',
                    },
                  ]}
                  className={styles.form_item}
                >
                  <Input
                    prefix={
                      needPrefix && <SafetyOutlined className={styles.icon} />
                    }
                    size={size || 'middle'}
                    placeholder="请输入图片验证码"
                    className={styles.form_input}
                  />
                </Form.Item>
              </div>
              <div className={styles['captcha-img']}>
                <Spin spinning={captchaLoading}>
                  <div
                    className={styles['captcha-img-container']}
                    style={{
                      backgroundImage: `url(${captchaCode})`,
                    }}
                    onClick={refreshCaptcha}
                  />
                </Spin>
              </div>
            </div>
          </Form.Item>
        )}
        <Form.Item
          name={name || 'smsCode'}
          label={isNeedLabel ? label || '短信验证码' : null}
          dependencies={['phoneNum', 'captcha']}
          className={styles.form_item}
          rules={[
            { required: true, message: '请输入短信验证码' },
            { len: 6, message: '请输入6位短信验证码' },
            ({ getFieldValue }) => ({
              validator(_, value) {
                // if (!isNotNeedPhone && value && !getFieldValue('phoneNum')) {
                //   return Promise.reject(new Error('请先输入手机号'));
                // }
                if (
                  !isNotNeedPhone &&
                  isNeedCaptcha &&
                  value &&
                  !getFieldValue('captcha')
                ) {
                  // return Promise.reject(new Error('请先输入图片验证码'));
                  validateFields(['captcha']);
                }
                return Promise.resolve();
              },
            }),
          ]}
        >
          <div>
            <Input
              prefix={needPrefix && <TabletOutlined className={styles.icon} />}
              size={size || 'middle'}
              placeholder="请输入短信验证码"
              className={styles.form_input}
              onChange={handleSmsCodeChange}
            />
            <Button
              type={'primary'}
              size={size || 'middle'}
              onClick={getCode}
              loading={isPending}
              className={styles.getcode}      
            >
              {isPending ? `请${count}秒后重发` : '获取验证码'}
            </Button>
          </div>
        </Form.Item>
      </div>
    );
  };